import ModalDrag from '@/component/ModaDrag/ModalDrag'
import { Button, Col, Input, message, Pagination, Row, Table, Tabs } from 'antd'
import React, { useEffect, useReducer, useRef, useState } from 'react'
import GlobalCss from '@/global.module.less'
import css from './add-dataset-to-case-exercise.module.less'
import { sendHttpPostRequest } from '@/api/http-request'
import SearchInputCom from '@/component/SearchInputCom/SearchInputCom'
import TabPane from 'antd/lib/tabs/TabPane'
import idataCourseTableStyles from '@/pages/common/global-styles/idatacourse-table.module.less'
import { BACKEND_API_URL } from '@/constants/constants'



function AddDatasetToCaseExerciseModal(props: any) {
  const { open, setOpen, actionCallback, actionDataset } = props
  const query = useRef('')
  const page = useRef(1)
  const pageSize = useRef(10)
  const order = useRef('') // 排序升序降序
  const order_by = useRef('') // 排序列
 

  const [exerciseTotalSum, setExerciseTotalSum] = useState(0)
  const [exerciseResultList, setExerciseResultList] = useState([])

  const [caseResultList, setCaseResultList] = useState([])
  const [caseTotalSum, setCaseTotalSum] = useState(0)

  const activeTabKey  =  useRef('1') // '1'  实验  '2' 实操题

  const selectedExercises = React.useRef([] as any) //选择的练习题
  const selectedCases = React.useRef([] as any) //选择的实验

  const [placeHolder, setPlaceHolder] = useState('搜索实验')


  /** 点击了确认  */
  const onOk = () => {
    if (activeTabKey.current == '1') { // 挂载到实验
      const case_id_list:any[] = []

      selectedCases.current.map((row:any) => {
        case_id_list.push(row.case_id)
      })
      let data = {
        dataset_id: actionDataset.id,
        case_id_list: JSON.stringify(case_id_list),
      }
  
      sendHttpPostRequest(
        'dataset/api/oam_mount_public_dataset_to_experiment/',
        data,
        (res) => {
          if (res.code == 0) {
            message.success('挂载到实验成功~')
            selectedCases.current = []
            query.current = ''
            page.current = 1
            setOpen(false)
            actionCallback && actionCallback()
          } else {
            message.error(res.message)
          }
        }
      )

    }else { // 挂载到 实操题
      const exercise_id_list:any[] = []

      selectedExercises.current.map((row:any) => {
        exercise_id_list.push(row.id)
      })
      let data = {
        dataset_id: actionDataset.id,
        exercise_id_list: JSON.stringify(exercise_id_list),
      }
  
      sendHttpPostRequest(
        'dataset/api/oam_mount_public_dataset_to_exercises/',
        data,
        (res) => {
          if (res.code == 0) {
            message.success('挂载到实操题成功~')
            selectedExercises.current = []
            query.current = ''
            page.current = 1
            setOpen(false)
            actionCallback && actionCallback()
          } else {
            message.error(res.message)
          }
        }
      )
  

    }
  }

  const onCancel = () => {
    selectedExercises.current = []
    selectedCases.current = []
    setOpen(false)
    query.current = ''
    page.current = 1
  }

  /** 查询系统习题，注意是实操题，过滤 */
  const getSystemExerciseList = () => {
    let data = {
      query: query.current,
      page: page.current,
      pagesize: pageSize.current,
      source:2,
      type:JSON.stringify([1]),
      difficulty:JSON.stringify([]),
      status:JSON.stringify([]),
      order: order.current,
      order_by: order_by.current,
    }
    sendHttpPostRequest('exercise/api/oam_query_exercise_list', data, (res) => {
      if (res.code == 0) {
        setExerciseResultList(res.exercise_list)
        setExerciseTotalSum(res.total_sum)
      }
    })
  }

    //选择习题
    const onExerciseSelection = {
      onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
        selectedExercises.current = selectedRows
      },
      getCheckboxProps: (record: any) => ({
        disabled: record?.mounted_dataset_id_list?.filter((item) => item == actionDataset?.id).length > 0,
      }),
    }

    //选择实验
    const onCaseSelection = {
      onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
        selectedCases.current = selectedRows
      },
      getCheckboxProps: (record: any) => ({
        disabled: record?.mounted_dataset_id_list?.filter((item) => item == actionDataset?.id).length > 0,
      }),
    }

    /** 查询系统实验 */
    const getSystemCaseList = () => {
      let data = {
        query: query.current,
        page: page.current,
        pagesize: pageSize.current,
        source:2,
        order: order.current,
        order_by: order_by.current,
      }
      sendHttpPostRequest('case/api/oam_query_case_list', data, (res) => {
        if (res.code == 0) {
          setCaseResultList(res.case_list)
          setCaseTotalSum(res.total_sum)
        }
      })
    }

  useEffect(() => {
    getSystemExerciseList()
    getSystemCaseList()
    return () => {}
  }, [])



  const onPageChange = (np, nps) => {
    page.current = np
    pageSize.current = nps
    if (activeTabKey.current == '1') {
      getSystemCaseList()
    } else {
      getSystemExerciseList()
    }
  }


    // 实验表格发生变化
    const onCaseTableChange: any = (
      pagination: any,
      filters: any,
      sorter: any,
      extra: { currentDataSource: []; action: any }
    ) => {
      if (sorter.order) {
        //如果选择了排序列
        order.current = sorter.order
        order_by.current = sorter.field
      }
      getSystemCaseList()
    }

    // 实操题表格发生变化
    const onExerciseTableChange: any = (
      pagination: any,
      filters: any,
      sorter: any,
      extra: { currentDataSource: []; action: any }
    ) => {
      if (sorter.order) {
        //如果选择了排序列
        order.current = sorter.order
        order_by.current = sorter.field
      }
      getSystemExerciseList()
    }

  // 切换Tab页
  const onTabKeyChange = (key: string) => {
    activeTabKey.current = key
    page.current = 1
    if (key == '1') {
      setPlaceHolder('搜索实验')
      getSystemCaseList()
    }else {
      setPlaceHolder('搜索实操题')
      getSystemExerciseList()
    }
      
  }

  const case_columns: any = [
    {
      title: 'ID',
      dataIndex: 'case_id',
      key: 'case_id',
      align: 'left',
      width: 80,
      ellipsis: true,
    },
    {
      title: '实验名称',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      align: 'left',
      width: 150,

    },
    {
      title: '创建者',
      dataIndex: 'creator_name',
      key: 'creator_name',
      align: 'left',
      width: 120,
      ellipsis: true,
      render: (t, r, i) => {
        return (
        <Row align="middle" wrap={false} justify="start" style={{width: 120, gap: '5px' }}>
            <Col>
            <img
                className={GlobalCss.avatar}
                src={BACKEND_API_URL + r.creator_avatar}
                alt=""
            />
            </Col>
            <Col>{t}</Col>
        </Row>
        )
    },
    },
    {
      title: '创建时间',
      dataIndex: 'create_datetime',
      key: 'create_datetime',
      align: 'center',
      width: 180,
      sorter: true,
      ellipsis: true,
      sortDirections: ['descend', 'ascend'],
      defaultSortOrder: 'descend',
    },
    {
      title: '操作',
      dataIndex: 'actions',
      key: 'actions',
      width: 80,
      ellipsis: true,
      align: 'center',
      //: 'right',
      render: (text: any, record: any) => {
        return (
          <Button
            //className={courseCreateStyles.modalBtn}
            type="default"
            size="small"
            style={{borderRadius:5, margin:'0px 10px', height: 28, width: 60, textShadow:'none', boxShadow:'none' }}
            onClick={()=>{ window.open('/oam-case-preview?case_id=' + record.case_id)}}
          >
            预览
          </Button>
        )
      },
    },
  ]



  const exercise_columns:any = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      align: 'left',
      width: 80,
      ellipsis: true,
      
    },
    {
      title: '题目名称',
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
      align: 'left',
      width: 100,
    },
    {
      title: '备注',
      dataIndex: 'remarks',
      key: 'remarks',
      align: 'left',
      width: 50,
      ellipsis: true,
    },

    {
      title: '创建者',
      dataIndex: 'creator',
      key: 'creator',
      align: 'left',  
      ellipsis: true,        
      width: 120,
      render: (t, r, i) => {
          return (
          <Row align="middle" wrap={false} justify="start" style={{width: 120, gap: '5px' }}>
              <Col>
              <img
                  className={GlobalCss.avatar}
                  src={BACKEND_API_URL + r.creator_avatar}
                  alt=""
              />
              </Col>
              <Col>{t}</Col>
          </Row>
          )
      },
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'center',
      width: 120,
      sorter: true,
      ellipsis: true,
      sortDirections: ['descend', 'ascend'],
      defaultSortOrder: 'descend',
    },
    {
      title: '操作',
      dataIndex: 'actions',
      key: 'actions',
      width: 80,
      ellipsis: true,
      align: 'center',
      render: (text: any, record: any) => {
        return (
          <Button
            //className={courseCreateStyles.modalBtn}
            type="default"
            size="small"
            style={{borderRadius:5, margin:'0px 10px', height: 28, width: 60, textShadow:'none', boxShadow:'none' }}
            onClick={()=>{ window.open('/oam_exercise_edit?exercise_id=' + record.id)}}
          >
            预览
          </Button>
        )
      },
    },

];

  const AddDatasetToTaskModalContent = (
    <div className={css.tabsWrapper}>
      <div style={{textAlign:'right', marginBottom:-32}}>
        <SearchInputCom
          placeholder={placeHolder}
          width={224}
          onChange={(e) => {
            query.current = e.target.value
          }}
          onSearch={() => {
            page.current = 1
            activeTabKey.current == '1'? getSystemCaseList():getSystemExerciseList()
          }}
        />
      </div>


      <Tabs defaultActiveKey="1" onChange={onTabKeyChange}>
        <TabPane tab="实验" key="1" className="">
          <div style={{height:490}} className={idataCourseTableStyles.tableWrapper}>
            <Table
              dataSource={caseResultList}
              columns={case_columns}
              pagination={false}
              rowKey={(r:any) => r.case_id}
              rowSelection={{
                type: 'checkbox',
                ...onCaseSelection,
              }}
              onChange={onCaseTableChange}
            />
        </div>
        <div style={{textAlign:'center'}}>
            <Pagination
                current={page.current}
                pageSize={pageSize.current}
                total={caseTotalSum}
                onChange={onPageChange}
                hideOnSinglePage
                showSizeChanger={false}
              />
        </div>
        </TabPane>
        <TabPane tab="实操题" key="2" className="">
          <div style={{height:490}}  className={idataCourseTableStyles.tableWrapper}>
            <Table
              dataSource={exerciseResultList}
              columns={exercise_columns}
              pagination={false}
              rowKey={(r: any) => r.id}

              rowSelection={{
                type: 'checkbox',
                ...onExerciseSelection,
              }}
              onChange={onExerciseTableChange}
            />
        </div>
        <div style={{textAlign:'center'}}>
            <Pagination
                current={page.current}
                pageSize={pageSize.current}
                total={exerciseTotalSum}
                onChange={onPageChange}
                hideOnSinglePage
                showSizeChanger={false}
              />
        </div>
        </TabPane>
      </Tabs>
    </div>
  )

  return (
    <ModalDrag
      destroyOnClose = {true}
      width={800}
      modalTitle={'添加到实验/实操题'}
      modalContent={AddDatasetToTaskModalContent}
      open={open}
      onCancel={() => setOpen(false)}
      footer={
        <Row align={'middle'} justify={'center'}>
          <Col className={GlobalCss.ColFlex} style={{ gap: '10px' }}>
            <Button style={{textShadow:'none', boxShadow:'none'}} type="default" onClick={onCancel}>
              取消
            </Button>
            <Button style={{textShadow:'none', boxShadow:'none', marginLeft: '20px'}} onClick={onOk} type="primary">
              确定
            </Button>
          </Col>
        </Row>
      }
    />
  )
}

export default AddDatasetToCaseExerciseModal
